export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const SITE_SIDEBAR = "SITE_SIDEBAR";

export const UPDATE_BILL_LINE_ITEM_START = "UPDATE_BILL_LINE_ITEM_START";
export const UPDATE_BILL_LINE_ITEM_SUCCESS = "UPDATE_BILL_LINE_ITEM_SUCCESS";
export const UPDATE_BILL_LINE_ITEM_FAIL = "UPDATE_BILL_LINE_ITEM_FAIL";

export const UPDATE_QUERY_LINE_ITEM_START = "UPDATE_QUERY_LINE_ITEM_START";
export const UPDATE_QUERY_LINE_ITEM_SUCCESS = "UPDATE_QUERY_LINE_ITEM_SUCCESS";
export const UPDATE_QUERY_LINE_ITEM_FAIL = "UPDATE_QUERY_LINE_ITEM_FAIL";

export const UPDATE_BILL_DETAILS_START = "UPDATE_BILL_DETAILS_START";
export const UPDATE_BILL_DETAILS_SUCCESS = "UPDATE_BILL_DETAILS_SUCCESS";
export const UPDATE_BILL_DETAILS_FAIL = "UPDATE_BILL_DETAILS_FAIL";

export const UPDATE_QUERY_DETAILS_START = "UPDATE_QUERY_DETAILS_START";
export const UPDATE_QUERY_DETAILS_SUCCESS = "UPDATE_QUERY_DETAILS_SUCCESS";
export const UPDATE_QUERY_DETAILS_FAIL = "UPDATE_QUERY_DETAILS_FAIL";

export const USER_LIST_START = "USER_LIST_START";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
export const USER_LIST_FILTER = "USER_LIST_FILTER";
export const USER_DETAIL = "USER_DETAIL";
export const USER_DELETE = "USER_DELETE";
export const USER_ROLE_LIST = "USER_ROLE_LIST";
export const USER_PLAN_LIST = "USER_PLAN_LIST";
export const USER_ADD_EDIT_START = "USER_ADD_EDIT_START";
export const USER_ADD_EDIT_SUCCESS = "USER_ADD_EDIT_SUCCESS";
export const USER_ADD_EDIT_FAIL = "USER_ADD_EDIT_FAIL";
export const USER_ORGANISATION_LIST = "USER_ORGANISATION_LIST";

export const FAQ_LIST_START = "FAQ_LIST_START";
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAIL = "FAQ_LIST_FAIL";
export const FAQ_DELETE = "FAQ_DELETE";
export const FAQ_DETAIL = "FAQ_DETAIL";
export const FAQ_ADD_EDIT_START = "FAQ_ADD_EDIT_START";
export const FAQ_ADD_EDIT_SUCCESS = "FAQ_ADD_EDIT_SUCCESS";
export const FAQ_ADD_EDIT_FAIL = "FAQ_ADD_EDIT_FAIL";

export const ROLE_LIST_START = "ROLE_LIST_START";
export const ROLE_LIST_SUCCESS = "ROLE_LIST_SUCCESS";
export const ROLE_LIST_FAIL = "ROLE_LIST_FAIL";
export const ROLE_LIST_FILTER = "ROLE_LIST_FILTER";
export const ROLE_DETAIL = "ROLE_DETAIL";
export const ROLE_ADD_EDIT_START = "ROLE_ADD_EDIT_START";
export const ROLE_ADD_EDIT_SUCCESS = "ROLE_ADD_EDIT_SUCCESS";
export const ROLE_ADD_EDIT_FAIL = "ROLE_ADD_EDIT_FAIL";
export const ROLE_DELETE = "ROLE_DELETE";
export const ROLE_COUNTRY_LIST = "ROLE_COUNTRY_LIST";
export const ROLE_STATE_LIST = "ROLE_STATE_LIST";
export const ROLE_USER_LIST_START = "ROLE_USER_LIST_START";
export const ROLE_USER_LIST_SUCCESS = "ROLE_USER_LIST_SUCCESS";
export const ROLE_USER_LIST_FAIL = "ROLEL_USER_LIST_FAIL";
export const ROLE_ADD_EDIT_SUCCESS_MESSAGE = "ROLE_ADD_EDIT_SUCCESS_MESSAGE";
export const ROLE_DETAIL_FAIL = "ROLE_DETAIL_FAIL";
export const ROLE_DETAIL_START = "ROLE_DETAIL_START";
export const ROLE_DETAIL_SUCCESS = "ROLE_DETAIL_SUCCESS";

export const MODULE_LIST = "MODULE_LIST";
export const MODULE_LIST_START = "MODULE_LIST";
export const MODULE_LIST_SUCCESS = "MODULE_LIST";
export const MODULE_LIST_FAIL = "MODULE_LIST";

export const EVENT_LIST_START = "EVENT_LIST_START";
export const EVENT_LIST_SUCCESS = "EVENT_LIST_SUCCESS";
export const EVENT_LIST_FAIL = "EVENT_LIST_FAIL";
export const EVENT_LIST_FILTER = "EVENT_LIST_FILTER";
export const EVENT_DETAIL = "EVENT_DETAIL";
export const EVENT_ADD_EDIT_START = "EVENT_ADD_EDIT_START";
export const EVENT_ADD_EDIT_SUCCESS = "EVENT_ADD_EDIT_SUCCESS";
export const EVENT_ADD_EDIT_FAIL = "EVENT_ADD_EDIT_FAIL";
export const EVENT_DELETE = "EVENT_DELETE";
export const EVENT_COUNTRY_LIST = "EVENT_COUNTRY_LIST";
export const EVENT_STATE_LIST = "EVENT_STATE_LIST";
export const EVENT_USER_LIST_START = "EVENT_USER_LIST_START";
export const EVENT_USER_LIST_SUCCESS = "EVENT_USER_LIST_SUCCESS";
export const EVENT_USER_LIST_FAIL = "EVENT_USER_LIST_FAIL";

export const LOG_LIST_START = "LOG_LIST_START";
export const LOG_LIST_SUCCESS = "LOG_LIST_SUCCESS";
export const LOG_LIST_FAIL = "LOG_LIST_FAIL";
export const LOG_LIST_FILTER = "LOG_LIST_FILTER";
export const LOG_LIST_REQUEST = "LOG_LIST_REQUEST";

export const FUND_LIST_START = "FUND_LIST_START";
export const FUND_LIST_SUCCESS = "FUND_LIST_SUCCESS";
export const FUND_LIST_FAIL = "FUND_LIST_FAIL";
export const FUND_LIST_FILTER = "FUND_LIST_FILTER";
export const FUND_DETAIL = "FUND_DETAIL";
export const FUND_ADD_EDIT_START = "FUND_ADD_EDIT_START";
export const FUND_ADD_EDIT_SUCCESS = "FUND_ADD_EDIT_SUCCESS";
export const FUND_ADD_EDIT_FAIL = "FUND_ADD_EDIT_FAIL";
export const FUND_DELETE = "FUND_DELETE";
export const FUND_CATEGORY_LIST = "FUND_CATEGORY_LIST";

export const DIGITAL_LIBRARY_LIST_START = "DIGITAL_LIBRARY_LIST_START";
export const DIGITAL_LIBRARY_LIST_SUCCESS = "DIGITAL_LIBRARY_LIST_SUCCESS";
export const DIGITAL_LIBRARY_LIST_FAIL = "DIGITAL_LIBRARY_LIST_FAIL";
export const DIGITAL_LIBRARY_LIST_FILTER = "DIGITAL_LIBRARY_LIST_FILTER";
export const DIGITAL_LIBRARY_DETAIL = "DIGITAL_LIBRARY_DETAIL";
export const DIGITAL_LIBRARY_ADD_EDIT_START = "DIGITAL_LIBRARY_ADD_EDIT_START";
export const DIGITAL_LIBRARY_ADD_EDIT_SUCCESS =
  "DIGITAL_LIBRARY_ADD_EDIT_SUCCESS";
export const DIGITAL_LIBRARY_ADD_EDIT_FAIL = "DIGITAL_LIBRARY_ADD_EDIT_FAIL";
export const DIGITAL_LIBRARY_DELETE = "DIGITAL_LIBRARY_DELETE";

export const TRANSACTION_LIST_START = "TRANSACTION_LIST_START";
export const TRANSACTION_LIST_SUCCESS = "TRANSACTION_LIST_SUCCESS";
export const TRANSACTION_LIST_FAIL = "TRANSACTION_LIST_FAIL";
export const TRANSACTION_LIST_FILTER = "TRANSACTION_LIST_FILTER";
export const TRANSACTION_STATUS = "TRANSACTION_STATUS";
export const TRANSACTION_DETAIL = "TRANSACTION_DETAIL";
export const TRANSACTION_ADD_EDIT_START = "TRANSACTION_ADD_EDIT_START";
export const TRANSACTION_ADD_EDIT_SUCCESS = "TRANSACTION_ADD_EDIT_SUCCESS";
export const TRANSACTION_ADD_EDIT_FAIL = "TRANSACTION_ADD_EDIT_FAIL";
export const TRANSACTION_DELETE = "TRANSACTION_DELETE";

export const BILL_LIST_START = "BILL_LIST_START";
export const BILL_LIST_SUCCESS = "BILL_LIST_SUCCESS";
export const BILL_LIST_FAIL = "BILL_LIST_FAIL";
export const BILL_LIST_FILTER = "BILL_LIST_FILTER";
export const BILL_DETAIL = "BILL_DETAIL";
export const BILL_STATUS = "BILL_STATUS";
export const BILL_ADD_EDIT_START = "BILL_ADD_EDIT_START";
export const BILL_ADD_EDIT_SUCCESS = "BILL_ADD_EDIT_SUCCESS";
export const BILL_ADD_EDIT_FAIL = "BILL_ADD_EDIT_FAIL";
export const BILL_DELETE = "BILL_DELETE";
export const BILL_DETAIL_START = "BILL_DETAIL_START";
export const BILL_DETAIL_SUCCESS = "BILL_DETAIL_SUCCESS";
export const BILL_DETAIL_FAIL = "BILL_DETAIL_FAIL";

export const QUERY_LIST_START = "QUERY_LIST_START";
export const QUERY_LIST_SUCCESS = "QUERY_LIST_SUCCESS";
export const QUERY_LIST_FAIL = "QUERY_LIST_FAIL";
export const QUERY_LIST_FILTER = "QUERY_LIST_FILTER";
export const QUERY_DETAIL = "QUERY_DETAIL";
export const QUERY_STATUS = "QUERY_STATUS";
export const QUERY_ADD_EDIT_START = "QUERY_ADD_EDIT_START";
export const QUERY_ADD_EDIT_SUCCESS = "QUERY_ADD_EDIT_SUCCESS";
export const QUERY_ADD_EDIT_FAIL = "QUERY_ADD_EDIT_FAIL";
export const QUERY_DELETE = "QUERY_DELETE";
export const QUERY_DETAIL_START = "QUERY_DETAIL_START";
export const QUERY_DETAIL_SUCCESS = "QUERY_DETAIL_SUCCESS";
export const QUERY_DETAIL_FAIL = "QUERY_DETAIL_FAIL";

export const GROUP_LIST_START = "GROUP_LIST_START";
export const GROUP_LIST_SUCCESS = "GROUP_LIST_SUCCESS";
export const GROUP_LIST_FAIL = "GROUP_LIST_FAIL";
export const GROUP_LIST_FILTER = "GROUP_LIST_FILTER";
export const GROUP_DETAIL = "GROUP_DETAIL";
export const GROUP_ADD_EDIT_START = "GROUP_ADD_EDIT_START";
export const GROUP_ADD_EDIT_SUCCESS = "GROUP_ADD_EDIT_SUCCESS";
export const GROUP_ADD_EDIT_FAIL = "GROUP_ADD_EDIT_FAIL";
export const GROUP_DELETE = "GROUP_DELETE";

export const CONTACT_LIST_START = "CONTACT_LIST_START";
export const CONTACT_LIST_SUCCESS = "CONTACT_LIST_SUCCESS";
export const CONTACT_LIST_FAIL = "CONTACT_LIST_FAIL";
export const CONTACT_DETAIL = "CONTACT_DETAIL";
export const CONTACT_ADD_EDIT_START = "CONTACT_ADD_EDIT_START";
export const CONTACT_ADD_EDIT_SUCCESS = "CONTACT_ADD_EDIT_SUCCESS";
export const CONTACT_ADD_EDIT_FAIL = "CONTACT_ADD_EDIT_FAIL";
export const CONTACT_DELETE = "CONTACT_DELETE";

export const REPLAY_LIST_START = "REPLAY_LIST_START";
export const REPLAY_LIST_SUCCESS = "REPLAY_LIST_SUCCESS";
export const REPLAY_LIST_FAIL = "REPLAY_LIST_FAIL";
export const REPLAY_LIST_FILTER = "REPLAY_LIST_FILTER";
export const REPLAY_DETAIL = "REPLAY_DETAIL";
export const REPLAY_ADD_EDIT_START = "REPLAY_ADD_EDIT_START";
export const REPLAY_ADD_EDIT_SUCCESS = "REPLAY_ADD_EDIT_SUCCESS";
export const REPLAY_ADD_EDIT_FAIL = "REPLAY_ADD_EDIT_FAIL";
export const REPLAY_DELETE = "REPLAY_DELETE";

export const USER_REQUEST_LIST_START = "USER_REQUEST_LIST_START";
export const USER_REQUEST_LIST_SUCCESS = "USER_REQUEST_LIST_SUCCESS";
export const USER_REQUEST_LIST_FAIL = "USER_REQUEST_LIST_FAIL";
export const USER_REQUEST_LIST_FILTER = "USER_REQUEST_LIST_FILTER";
export const USER_REQUEST_STATUS_UPDATE = "USER_REQUEST_STATUS_UPDATE";
export const USER_REQUEST_UPDATE_START = "USER_REQUEST_UPDATE_START";
export const USER_REQUEST_UPDATE_FAIL = "USER_REQUEST_UPDATE_FAIL";
export const USER_REQUEST_DETAIL = "USER_REQUEST_DETAIL";

export const DASHBOARD_LIST_START = "DASHBOARD_LIST_START";
export const DASHBOARD_LIST_SUCCESS = "DASHBOARD_LIST_SUCCESS";
export const DASHBOARD_LIST_FAIL = "DASHBOARD_LIST_FAIL";
export const DASHBOARD_DETAIL = "DASHBOARD_DETAIL";

export const EDIT_PROFILE_START = "EDIT_PROFILE_START";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAIL = "EDIT_PROFILE_FAIL";

export const EDIT_PROFILE_UPDATE_START = "EDIT_PROFILE_UPDATE_START";
export const EDIT_PROFILE_UPDATE_SUCCESS = "EDIT_PROFILE_UPDATE_SUCCESS";
export const EDIT_PROFILE_UPDATE_FAIL = "EDIT_PROFILE_UPDATE_FAIL";
export const EDIT_PROFILE_DETAIL = "EDIT_PROFILE_DETAIL";
